/* eslint-disable @typescript-eslint/naming-convention */
export enum PermissionConsts {
    // Pages
    Pages_Users = 'PagesUsers',
    Pages_Services = 'PagesServices',
    Pages_Role = 'PagesRoles',
    Pages_Activities = 'PagesActivities',
    Pages_SocialHealthRecords = 'PagesSocialHealthRecords',
    Pages_Records = 'PagesRecords',
    Pages_SocialHealthRecordTemplates = 'PagesSocialHealthRecordTemplates',

    // Roles
    Role_Create = 'RoleCreate',
    Role_Update = 'RoleUpdate',
    Role_Get = 'RoleGet',
    Role_Delete = 'RoleDelete',
    Role_GetAll = 'RoleGetAll',

    // Alert
    Alert_Create = 'AlertCreate',
    Alert_Update = 'AlertUpdate',
    Alert_Get = 'AlertGet',
    Alert_GetAll = 'AlertGetAll',
    Alert_Delete = 'AlertDelete',

    // User
    User_Create = 'UserCreate',
    User_Detail = 'UserDetail',
    User_Edit = 'UserEdit',
    User_Delete = 'UserDelete',
    User_Get = 'UserGet',
    User_GetAll = 'UserGetAll',
    User_GetAllOperatorLike = 'UserGetAllAssignableAsOperator',
    User_GetAllBeneficiaryLike = 'UserGetAllAssignableAsBeneficiary',
    User_GetAllBackOfficeLike = 'UserGetAllAssignableAsBackOffice',
    User_UpdateMyProfile = 'UserUpdateMyProfile',
    User_Deactivate = 'UserDeactivate',
    User_Archive = 'UserArchive',
    User_Unarchive = 'UserUnarchive',

    // Services
    Service_Create = 'ServiceCreate',
    Service_Update = 'ServiceUpdate',
    Service_Detail = 'ServiceDetail',
    Service_List = 'ServiceList',
    Service_Delete = 'ServiceDelete',
    Service_Export = 'ServiceExport',
    Service_ListAll = 'ServiceListAll',

    // ServiceWidget
    ServiceWidget_Create = 'ServiceWidgetCreate',
    ServiceWidget_Update = 'ServiceWidgetUpdate',
    ServiceWidget_Detail = 'ServiceWidgetDetail',
    ServiceWidget_List = 'ServiceWidgetList',
    ServiceWidget_Delete = 'ServiceWidgetDelete',
    ServiceWidget_Export = 'ServiceWidgetExport',

    // ServiceTemplates
    ServiceTemplate_Create = 'ServiceTemplateCreate',
    ServiceTemplate_Update = 'ServiceTemplateUpdate',
    ServiceTemplate_Detail = 'ServiceTemplateDetail',
    ServiceTemplate_List = 'ServiceTemplateList',
    ServiceTemplate_Delete = 'ServiceTemplateDelete',
    ServiceTemplate_Export = 'ServiceTemplateExport',

    // ServiceUsers
    ServiceUsers_Create = 'ServiceUsersCreate',
    ServiceUsers_Update = 'ServiceUsersUpdate',
    ServiceUsers_Detail = 'ServiceUsersDetail',
    ServiceUsers_List = 'ServiceUsersList',
    ServiceUsers_Delete = 'ServiceUsersDelete',
    ServiceUsers_Archive = 'ServiceUsersArchive',
    ServiceUsers_Unarchive = 'ServiceUsersUnarchive',
    ServiceUsers_Export = 'ServiceUsersExport',

    // Organization
    Organization_Create = 'OrganizationCreate',
    Organization_Update = 'OrganizationUpdate',
    Organization_Detail = 'OrganizationDetail',
    Organization_List = 'OrganizationList',
    Organization_Delete = 'OrganizationDelete',
    Organization_Export = 'OrganizationExport',

    // Activities
    Activity_Create = 'ActivityCreate',
    Activity_Update = 'ActivityUpdate',
    Activity_Delete = 'ActivityDelete',
    Activity_List = 'ActivityList',
    OperatorActivity_List = 'OperatorActivityList',
    OperatorActivity_Cancel = 'OperatorActivityCancel',
    OperatorActivity_Reschedule = 'OperatorActivityReschedule',
    OperatorActivity_Badge = 'OperatorActivityBadge',
    Activity_Detail = 'ActivityDetail',
    Activity_Export = 'ActivityExport',
    Activity_RebuildOccurrences = 'ActivityRebuildOccurrences',
    ServiceActivity_Update = 'ServiceActivityUpdate',

    // Structure
    Structure_GetAll = 'StructureGetAll',
    Structure_Get = 'StructureGet',
    Structure_Create = 'StructureCreate',
    Structure_Update = 'StructureUpdate',
    Structure_Delete = 'StructureDelete',

    // ServiceStructure
    ServiceStructure_Create = 'ServiceStructureCreate',
    ServiceStructure_List = 'ServiceStructureList',
    ServiceStructure_Detail = 'ServiceStructureDetail',
    ServiceStructure_Delete = 'ServiceStructureDelete',

    // StructureWidget
    StructureWidget_Get = 'StructureWidgetGet',
    StructureWidget_GetAll = 'StructureWidgetGetAll',

    // StructureTemplate
    StructureTemplate_Create = 'StructureTemplateCreate',
    StructureTemplate_Update = 'StructureTemplateUpdate',
    StructureTemplate_Get = 'StructureTemplateGet',
    StructureTemplate_GetAll = 'StructureTemplateGetAll',
    StructureTemplate_Delete = 'StructureTemplateDelete',

    // StructureDetail
    StructureDetail_Create = 'StructureDetailCreate',
    StructureDetail_Update = 'StructureDetailUpdate',
    StructureDetail_Get = 'StructureDetailGet',
    StructureDetail_GetAll = 'StructureDetailGetAll',
    StructureDetail_Delete = 'StructureDetailDelete',

    // Room
    Room_Create = 'RoomCreate',
    Room_Update = 'RoomUpdate',
    Room_Get = 'RoomGet',
    Room_GetAll = 'RoomGetAll',
    Room_Delete = 'RoomDelete',
    ServiceUserStructure_List = 'ServiceUserStructureList',
    ServiceUserStructure_Assign = 'ServiceUserStructureAssign',
    ServiceUserStructure_Unassign = 'ServiceUserStructureUnassign',
    StructureRegistryData_Create = 'StructureRegistryDataCreate',
    StructureRegistryData_Update = 'StructureRegistryDataUpdate',
    StructureRegistryData_Get = 'StructureRegistryDataGet',
    StructureRegistryData_GetAll = 'StructureRegistryDataGetAll',
    StructureRegistryData_Delete = 'StructureRegistryDataDelete',

    // RolesDifference
    Role_OperatorLike = 'RoleIsAssignableAsOperator',
    Role_BeneficiaryLike = 'RoleIsAssignableAsBeneficiary',
    Role_BackOfficeLike = 'RoleIsAssignableAsBackOffice',

    // Files
    File_List = 'FileList',
    File_Detail = 'FileDetail',
    File_Create = 'FileCreate',
    File_Delete = 'FileDelete',
    File_Export = 'FileExport',

    // SocialHealthRecords
    SocialHealthRecords_Create = 'SocialHealthRecordsCreate',
    SocialHealthRecords_Update = 'SocialHealthRecordsUpdate',
    SocialHealthRecords_Delete = 'SocialHealthRecordsDelete',
    SocialHealthRecords_List = 'SocialHealthRecordsList',
    SocialHealthRecords_Detail = 'SocialHealthRecordsDetail',
    SocialHealthRecords_GetByUser = 'SocialHealthRecordsGetByUser',
    SocialHealthRecords_Export = 'SocialHealthRecordsExport',

    // SocialHealthRecordExtensionDates
    SocialHealthRecordExtensionDate_Create = 'SocialHealthRecordExtensionDateCreate',
    SocialHealthRecordExtensionDate_Update = 'SocialHealthRecordExtensionDateUpdate',
    SocialHealthRecordExtensionDate_Delete = 'SocialHealthRecordExtensionDateDelete',
    SocialHealthRecordExtensionDate_List = 'SocialHealthRecordExtensionDateList',
    SocialHealthRecordExtensionDate_Detail = 'SocialHealthRecordExtensionDateDetail',
    SocialHealthRecordExtensionDate_GetByUser = 'SocialHealthRecordExtensionDateGetByUser',
    SocialHealthRecordExtensionDate_Export = 'SocialHealthRecordExtensionDateExport',

    // CaregiverRecord
    CaregiverRecord_Create = 'CaregiverRecordCreate',
    CaregiverRecord_Update = 'CaregiverRecordUpdate',
    CaregiverRecord_Get = 'CaregiverRecordGet',
    CaregiverRecord_GetAll = 'CaregiverRecordGetAll',
    CaregiverRecord_Delete = 'CaregiverRecordDelete',
    CaregiverRecord_Export = 'CaregiverRecordExport',

    // DoctorRecords
    DoctorRecords_Create = 'DoctorRecordsCreate',
    DoctorRecord_Update = 'DoctorRecordUpdate',
    DoctorRecord_Get = 'DoctorRecordGet',
    DoctorRecord_GetAll = 'DoctorRecordGetAll',
    DoctorRecord_Delete = 'DoctorRecordDelete',
    DoctorRecord_Export = 'DoctorRecordExport',

    // AdmissionResidanceAuthorizations
    AdmissionResidanceAuthorization_Create = 'AdmissionResidanceAuthorizationCreate',
    AdmissionResidanceAuthorization_Update = 'AdmissionResidanceAuthorizationUpdate',
    AdmissionResidanceAuthorization_Get = 'AdmissionResidanceAuthorizationGet',
    AdmissionResidanceAuthorization_GetAll = 'AdmissionResidanceAuthorizationGetAll',
    AdmissionResidanceAuthorization_Delete = 'AdmissionResidanceAuthorizationDelete',

    // AdmissionRecord
    AdmissionRecord_Create = 'AdmissionRecordCreate',
    AdmissionRecord_Update = 'AdmissionRecordUpdate',
    AdmissionRecord_Get = 'AdmissionRecordGet',
    AdmissionRecord_GetAll = 'AdmissionRecordGetAll',
    AdmissionRecord_Delete = 'AdmissionRecordDelete',

    // Drug
    Drug_Create = 'DrugCreate',
    Drug_Update = 'DrugUpdate',
    Drug_Get = 'DrugGet',
    Drug_GetAll = 'DrugGetAll',
    Drug_Delete = 'DrugDelete',

    // HistoricalCase
    HistoricalCase_Create = 'HistoricalCaseCreate',
    HistoricalCase_Update = 'HistoricalCaseUpdate',
    HistoricalCase_Get = 'HistoricalCaseGet',
    HistoricalCase_GetAll = 'HistoricalCaseGetAll',
    HistoricalCase_Delete = 'HistoricalCaseDelete',

    // PersonalAutonomy
    PersonalAutonomy_Create = 'PersonalAutonomyCreate',
    PersonalAutonomy_Update = 'PersonalAutonomyUpdate',
    PersonalAutonomy_Get = 'PersonalAutonomyGet',
    PersonalAutonomy_GetAll = 'PersonalAutonomyGetAll',
    PersonalAutonomy_Delete = 'PersonalAutonomyDelete',

    // AdmissionResidentialAuthorization
    AdmissionResidentialAuthorization_Create = 'AdmissionResidentialAuthorizationCreate',
    AdmissionResidentialAuthorization_Update = 'AdmissionResidentialAuthorizationUpdate',
    AdmissionResidentialAuthorization_Get = 'AdmissionResidentialAuthorizationGet',
    AdmissionResidentialAuthorization_GetAll = 'AdmissionResidentialAuthorizationGetAll',
    AdmissionResidentialAuthorization_Delete = 'AdmissionResidentialAuthorizationDelete',

    // EducationalTraining
    EducationalTraining_Create = 'EducationalTrainingCreate',
    EducationalTraining_Update = 'EducationalTrainingUpdate',
    EducationalTraining_Get = 'EducationalTrainingGet',
    EducationalTraining_GetAll = 'EducationalTrainingGetAll',
    EducationalTraining_Delete = 'EducationalTrainingDelete',

    // FamilyComponent
    FamilyComponent_Create = 'FamilyComponentCreate',
    FamilyComponent_Update = 'FamilyComponentUpdate',
    FamilyComponent_Get = 'FamilyComponentGet',
    FamilyComponent_GetAll = 'FamilyComponentGetAll',
    FamilyComponent_Delete = 'FamilyComponentDelete',

    // HousingSituation
    HousingSituation_Create = 'HousingSituationCreate',
    HousingSituation_Update = 'HousingSituationUpdate',
    HousingSituation_Get = 'HousingSituationGet',
    HousingSituation_GetAll = 'HousingSituationGetAll',
    HousingSituation_Delete = 'HousingSituationDelete',

    // IncomeAllowance
    IncomeAllowance_Create = 'IncomeAllowanceCreate',
    IncomeAllowance_Update = 'IncomeAllowanceUpdate',
    IncomeAllowance_Get = 'IncomeAllowanceGet',
    IncomeAllowance_GetAll = 'IncomeAllowanceGetAll',
    IncomeAllowance_Delete = 'IncomeAllowanceDelete',

    // ProtectionMeasure
    ProtectionMeasure_Create = 'ProtectionMeasureCreate',
    ProtectionMeasure_Update = 'ProtectionMeasureUpdate',
    ProtectionMeasure_Get = 'ProtectionMeasureGet',
    ProtectionMeasure_GetAll = 'ProtectionMeasureGetAll',
    ProtectionMeasure_Delete = 'ProtectionMeasureDelete',

    // SocialInvestigationRecord
    SocialInvestigationRecord_Create = 'SocialInvestigationRecordCreate',
    SocialInvestigationRecord_Update = 'SocialInvestigationRecordUpdate',
    SocialInvestigationRecord_Get = 'SocialInvestigationRecordGet',
    SocialInvestigationRecord_GetAll = 'SocialInvestigationRecordGetAll',
    SocialInvestigationRecord_Delete = 'SocialInvestigationRecordDelete',

    // Record
    Record_Create = 'RecordCreate',
    Record_Update = 'RecordUpdate',
    Record_Get = 'RecordGet',
    Record_GetAll = 'RecordGetAll',
    Record_Delete = 'RecordDelete',

    // SocialHealthRecordTemplate
    SocialHealthRecordTemplate_Create = 'SocialHealthRecordTemplateCreate',
    SocialHealthRecordTemplate_Update = 'SocialHealthRecordTemplateUpdate',
    SocialHealthRecordTemplate_Delete = 'SocialHealthRecordTemplateDelete',
    SocialHealthRecordTemplate_GetAll = 'SocialHealthRecordTemplateGetAll',
    SocialHealthRecordTemplate_Get = 'SocialHealthRecordTemplateGet',

    // SectionObservationGrid
    SectionObservationGrid_Create = 'SectionObservationGridCreate',
    SectionObservationGrid_Update = 'SectionObservationGridUpdate',
    SectionObservationGrid_Get = 'SectionObservationGridGet',
    SectionObservationGrid_GetAll = 'SectionObservationGridGetAll',
    SectionObservationGrid_Delete = 'SectionObservationGridDelete',

    // ScopeObservationGrid
    ScopeObservationGrid_Create = 'ScopeObservationGridCreate',
    ScopeObservationGrid_Update = 'ScopeObservationGridUpdate',
    ScopeObservationGrid_Get = 'ScopeObservationGridGet',
    ScopeObservationGrid_GetAll = 'ScopeObservationGridGetAll',
    ScopeObservationGrid_Delete = 'ScopeObservationGridDelete',

    // CategoryObservationGrid
    CategoryObservationGrid_Create = 'CategoryObservationGridCreate',
    CategoryObservationGrid_Update = 'CategoryObservationGridUpdate',
    CategoryObservationGrid_Get = 'CategoryObservationGridGet',
    CategoryObservationGrid_GetAll = 'CategoryObservationGridGetAll',
    CategoryObservationGrid_Delete = 'CategoryObservationGridDelete',

    // ObservationGrid
    ObservationGrid_Create = 'ObservationGridCreate',
    ObservationGrid_Update = 'ObservationGridUpdate',
    ObservationGrid_Get = 'ObservationGridGet',
    ObservationGrid_GetAll = 'ObservationGridGetAll',
    ObservationGrid_Delete = 'ObservationGridDelete',
    ObservationGrid_EditAfterConfirmed = 'ObservationGridEditAfterConfirmed',

    // ResponseObservationGrid
    ResponseObservationGrid_Create = 'ResponseObservationGridCreate',
    ResponseObservationGrid_Update = 'ResponseObservationGridUpdate',
    ResponseObservationGrid_Get = 'ResponseObservationGridGet',
    ResponseObservationGrid_GetAll = 'ResponseObservationGridGetAll',
    ResponseObservationGrid_Delete = 'ResponseObservationGridDelete',

    // SocialHealthRecordOperatorPermission
    SocialHealthRecordOperatorPermission_Create = 'SocialHealthRecordOperatorPermissionCreate',
    SocialHealthRecordOperatorPermission_GetAll = 'SocialHealthRecordOperatorPermissionGetAll',
    SocialHealthRecordOperatorPermission_Delete = 'SocialHealthRecordOperatorPermissionDelete',

    // ObservationGridSectionOperatorPermission
    ObservationGridSectionOperatorPermission_GetAll = 'ObservationGridSectionOperatorPermissionGetAll',
    ObservationGridSectionOperatorPermission_Create = 'ObservationGridSectionOperatorPermissionCreate',

    // ServiceAttendanceRegister
    ServiceAttendanceRegister_Create = 'ServiceAttendanceRegisterCreate',
    ServiceAttendanceRegister_Update = 'ServiceAttendanceRegisterUpdate',
    ServiceAttendanceRegister_Detail = 'ServiceAttendanceRegisterDetail',
    ServiceAttendanceRegister_List = 'ServiceAttendanceRegisterList',
    ServiceAttendanceRegister_Delete = 'ServiceAttendanceRegisterDelete',
    ServiceAttendanceRegister_Export = 'ServiceAttendanceRegisterExport',

    // ServiceLog
    ServiceLog_Create = 'ServiceLogCreate',
    ServiceLog_Update = 'ServiceLogUpdate',
    ServiceLog_Get = 'ServiceLogGet',
    ServiceLog_GetAll = 'ServiceLogGetAll',
    ServiceLog_Delete = 'ServiceLogDelete',
    ServiceLog_GetMine = 'ServiceLogGetMine',
    ServiceLog_DeleteMine = 'ServiceLogDeleteMine',
    ServiceLog_ManageLinkedDiaries = 'ServiceLogManageLinkedDiaries',

    // Tag
    Tag_Create = 'TagCreate',
    Tag_Update = 'TagUpdate',

    // ServiceTag
    ServiceTag_Get = 'ServiceTagGet',
    ServiceTag_GetAll = 'ServiceTagGetAll',
    ServiceTag_Create = 'ServiceTagCreate',
    ServiceTag_Delete = 'ServiceTagDelete',

    // ServiceSubTag
    ServiceSubTag_Get = 'ServiceSubTagGet',
    ServiceSubTag_GetAll = 'ServiceSubTagGetAll',
    ServiceSubTag_Create = 'ServiceSubTagCreate',
    ServiceSubTag_Delete = 'ServiceSubTagDelete',

    // Task
    Task_Create = 'TaskCreate',
    Task_Update = 'TaskUpdate',

    // ServiceTask
    ServiceTask_Create = 'ServiceTaskCreate',
    ServiceTask_Update = 'ServiceTaskUpdate',
    ServiceTask_Get = 'ServiceTaskGet',
    ServiceTask_GetAll = 'ServiceTaskGetAll',
    ServiceTask_Delete = 'ServiceTaskDelete',

    // ServiceLogServiceTask
    ServiceLogServiceTask_Update = 'ServiceLogServiceTaskUpdate',

    // CustomDataTemplate
    CustomDataTemplate_Create = 'CustomDataTemplateCreate',
    CustomDataTemplate_Update = 'CustomDataTemplateUpdate',
    CustomDataTemplate_Delete = 'CustomDataTemplateDelete',
    CustomDataTemplate_Get = 'CustomDataTemplateGet',
    CustomDataTemplate_GetAll = 'CustomDataTemplateGetAll',

    // Asset
    Asset_Create = 'AssetCreate',
    Asset_Update = 'AssetUpdate',
    Asset_Delete = 'AssetDelete',
    Asset_Get = 'AssetGet',
    Asset_GetAll = 'AssetGetAll',

    // AssetServiceUser
    AssetServiceUser_Create = 'AssetServiceUserCreate',
    AssetServiceUser_Update = 'AssetServiceUserUpdate',
    AssetServiceUser_Delete = 'AssetServiceUserDelete',
    AssetServiceUser_Get = 'AssetServiceUserGet',
    AssetServiceUser_GetAll = 'AssetServiceUserGetAll',

    // Vehicle
    Vehicle_Create = 'VehicleCreate',
    Vehicle_Update = 'VehicleUpdate',
    Vehicle_Get = 'VehicleGet',
    Vehicle_GetAll = 'VehicleGetAll',
    Vehicle_Delete = 'VehicleDelete',

    // VehicleAdditionalData
    VehicleAdditionalData_Create = 'VehicleAdditionalDataCreate',
    VehicleAdditionalData_Update = 'VehicleAdditionalDataUpdate',
    VehicleAdditionalData_Get = 'VehicleAdditionalDataGet',
    VehicleAdditionalData_GetAll = 'VehicleAdditionalDataGetAll',
    VehicleAdditionalData_Delete = 'VehicleAdditionalDataDelete',

    // InputCard
    InputCard_Create = 'InputCardCreate',
    InputCard_Update = 'InputCardUpdate',
    InputCard_Get = 'InputCardGet',
    InputCard_GetAll = 'InputCardGetAll',

    // PersonalDataFamilyMember
    PersonalDataFamilyMember_Create = 'PersonalDataFamilyMemberCreate',
    PersonalDataFamilyMember_Update = 'PersonalDataFamilyMemberUpdate',
    PersonalDataFamilyMember_Get = 'PersonalDataFamilyMemberGet',
    PersonalDataFamilyMember_GetAll = 'PersonalDataFamilyMemberGetAll',
    PersonalDataFamilyMember_Delete = 'PersonalDataFamilyMemberDelete',

    // SchoolWork
    SchoolWork_Create = 'SchoolWorkCreate',
    SchoolWork_Update = 'SchoolWorkUpdate',
    SchoolWork_Get = 'SchoolWorkGet',
    SchoolWork_GetAll = 'SchoolWorkGetAll',

    // HealthSocialWelfareService
    HealthSocialWelfareService_Create = 'HealthSocialWelfareServiceCreate',
    HealthSocialWelfareService_Update = 'HealthSocialWelfareServiceUpdate',
    HealthSocialWelfareService_Get = 'HealthSocialWelfareServiceGet',
    HealthSocialWelfareService_GetAll = 'HealthSocialWelfareServiceGetAll',

    // SpontaneousReportingEvent
    SpontaneousReportingEvent_Create = 'SpontaneousReportingEventCreate',
    SpontaneousReportingEvent_Update = 'SpontaneousReportingEventUpdate',
    SpontaneousReportingEvent_Get = 'SpontaneousReportingEventGet',
    SpontaneousReportingEvent_GetAll = 'SpontaneousReportingEventGetAll',
    SpontaneousReportingEvent_Delete = 'SpontaneousReportingEventDelete',
    SpontaneousReportingEvent_EditAfterConfirmed = 'SpontaneousReportingEventEditAfterConfirmed',

    // FallReport
    FallReport_Create = 'FallReportCreate',
    FallReport_Update = 'FallReportUpdate',
    FallReport_Get = 'FallReportGet',
    FallReport_GetAll = 'FallReportGetAll',
    FallReport_Delete = 'FallReportDelete',
    FallReport_EditAfterConfirmed = 'FallReportEditAfterConfirmed',

    // ConleyScale
    ConleyScale_Create = 'ConleyScaleCreate',
    ConleyScale_Update = 'ConleyScaleUpdate',
    ConleyScale_Get = 'ConleyScaleGet',
    ConleyScale_GetAll = 'ConleyScaleGetAll',
    ConleyScale_Delete = 'ConleyScaleDelete',
    ConleyScale_EditAfterConfirmed = 'ConleyScaleEditAfterConfirmed',

    // Autonomy
    Autonomy_Create = 'AutonomyCreate',
    Autonomy_Update = 'AutonomyUpdate',
    Autonomy_Get = 'AutonomyGet',
    Autonomy_GetAll = 'AutonomyGetAll',

    // MaintenanceEvent
    MaintenanceEvent_Create = 'MaintenanceEventCreate',
    MaintenanceEvent_Update = 'MaintenanceEventUpdate',
    MaintenanceEvent_Get = 'MaintenanceEventGet',
    MaintenanceEvent_GetAll = 'MaintenanceEventGetAll',
    MaintenanceEvent_Delete = 'MaintenanceEventDelete',

    // VehicleServiceUser
    VehicleServiceUser_Create = 'VehicleServiceUserCreate',
    VehicleServiceUser_Update = 'VehicleServiceUserUpdate',
    VehicleServiceUser_Get = 'VehicleServiceUserGet',
    VehicleServiceUser_GetAll = 'VehicleServiceUserGetAll',
    VehicleServiceUser_Delete = 'VehicleServiceUserDelete',

    // Verbals
    Verbal_Create = 'VerbalCreate',
    Verbal_Update = 'VerbalUpdate',
    Verbal_Delete = 'VerbalDelete',
    Verbal_Get = 'VerbalGet',
    Verbal_GetAll = 'VerbalGetAll',
    Verbal_Export = 'VerbalExport',
    Verbal_EditAfterConfirmed = 'VerbalEditAfterConfirmed',

    // ServiceReports
    ServiceReport_Create = 'ServiceReportCreate',
    ServiceReport_Update = 'ServiceReportUpdate',
    ServiceReport_Delete = 'ServiceReportDelete',
    ServiceReport_Get = 'ServiceReportGet',
    ServiceReport_GetAll = 'ServiceReportGetAll',
    ServiceReport_Export = 'ServiceReportExport',
    ServiceReport_EditAfterConfirmed = 'ServiceReportEditAfterConfirmed',

    // VerbalTags
    VerbalTag_Create = 'VerbalTagCreate',
    VerbalTag_Update = 'VerbalTagUpdate',
    VerbalTag_Delete = 'VerbalTagDelete',
    VerbalTag_Get = 'VerbalTagGet',
    VerbalTag_GetAll = 'VerbalTagGetAll',

    // ServiceVerbalTags
    ServiceVerbalTag_Create = 'ServiceVerbalTagCreate',
    ServiceVerbalTag_Update = 'ServiceVerbalTagUpdate',
    ServiceVerbalTag_Delete = 'ServiceVerbalTagDelete',
    ServiceVerbalTag_Get = 'ServiceVerbalTagGet',
    ServiceVerbalTag_GetAll = 'ServiceVerbalTagGetAll',

    // VerbalNotes
    VerbalNote_Create = 'VerbalNoteCreate',
    VerbalNote_Update = 'VerbalNoteUpdate',
    VerbalNote_Get = 'VerbalNoteGet',
    VerbalNote_GetAll = 'VerbalNoteGetAll',
    VerbalNote_Delete = 'VerbalNoteDelete',

    // IRP
    IntegratedRehabilitationPlanRecord_EditFinalReport = 'IntegratedRehabilitationPlanRecordEditFinalReport',

    // ServiceWeeklySchedules
    ServiceWeeklySchedule_Create = 'ServiceWeeklyScheduleCreate',
    ServiceWeeklySchedule_Get = 'ServiceWeeklyScheduleGet',
    ServiceWeeklySchedule_Update = 'ServiceWeeklyScheduleUpdate',
    ServiceWeeklySchedule_GetAll = 'ServiceWeeklyScheduleGetAll',
    ServiceWeeklySchedule_Delete = 'ServiceWeeklyScheduleDelete',

    // Place
    Place_Create = 'PlaceCreate',
    Place_Update = 'PlaceUpdate',

    // ServicePlace
    ServicePlace_Create = 'ServicePlaceCreate',
    ServicePlace_List = 'ServicePlaceList',
    ServicePlace_Detail = 'ServicePlaceDetail',
    ServicePlace_Delete = 'ServicePlaceDelete',

    // ServiceSemiAnnualHealthDocumentationReview
    ServiceSemiAnnualHealthDocumentationReview_Create = 'ServiceSemiAnnualHealthDocumentationReviewCreate',
    ServiceSemiAnnualHealthDocumentationReview_Update = 'ServiceSemiAnnualHealthDocumentationReviewUpdate',
    ServiceSemiAnnualHealthDocumentationReview_Get = 'ServiceSemiAnnualHealthDocumentationReviewGet',
    ServiceSemiAnnualHealthDocumentationReview_GetAll = 'ServiceSemiAnnualHealthDocumentationReviewGetAll',
    ServiceSemiAnnualHealthDocumentationReview_Delete = 'ServiceSemiAnnualHealthDocumentationReviewDelete',
    ServiceSemiAnnualHealthDocumentationReview_EditAfterConfirmed = 'ServiceSemiAnnualHealthDocumentationReviewEditAfterConfirmed',

    // CheckDrugExpiration
    CheckDrugExpiration_Create = 'CheckDrugExpirationCreate',
    CheckDrugExpiration_Update = 'CheckDrugExpirationUpdate',
    CheckDrugExpiration_Get = 'CheckDrugExpirationGet',
    CheckDrugExpiration_GetAll = 'CheckDrugExpirationGetAll',
    CheckDrugExpiration_Delete = 'CheckDrugExpirationDelete',
    CheckDrugExpiration_EditAfterConfirmed = 'CheckDrugExpirationEditAfterConfirmed',

    // ServiceUserAvailability
    ServiceUserAvailability_Create = 'ServiceUserAvailabilityCreate',
    ServiceUserAvailability_Update = 'ServiceUserAvailabilityUpdate',
    ServiceUserAvailability_Get = 'ServiceUserAvailabilityGet',
    ServiceUserAvailability_GetAll = 'ServiceUserAvailabilityGetAll',
    ServiceUserAvailability_Delete = 'ServiceUserAvailabilityDelete',

    // FileTags
    FileTag_Create = 'FileTagCreate',
    FileTag_Update = 'FileTagUpdate',
    ServiceFileTag_Delete = 'ServiceFileTagDelete',
    ServiceFileTag_Create = 'ServiceFileTagCreate',
    ServiceFileTag_Get = 'ServiceFileTagGet',
    ServiceFileTag_GetAll = 'ServiceFileTagGetAll',

    // HeatingSystem
    HeatingSystem_Create = 'HeatingSystemCreate',
    HeatingSystem_Update = 'HeatingSystemUpdate',
    HeatingSystem_Delete = 'HeatingSystemDelete',
    HeatingSystem_Get = 'HeatingSystemGet',
    HeatingSystem_GetAll = 'HeatingSystemGetAll',

    // HydraulicSystem
    HydraulicSystem_Create = 'HydraulicSystemCreate',
    HydraulicSystem_Update = 'HydraulicSystemUpdate',
    HydraulicSystem_Get = 'HydraulicSystemGet',
    HydraulicSystem_GetAll = 'HydraulicSystemGetAll',
    HydraulicSystem_Delete = 'HydraulicSystemDelete',

    // AirTreatmentSystem
    AirTreatmentSystem_Create = 'AirTreatmentSystemCreate',
    AirTreatmentSystem_Update = 'AirTreatmentSystemUpdate',
    AirTreatmentSystem_Get = 'AirTreatmentSystemGet',
    AirTreatmentSystem_GetAll = 'AirTreatmentSystemGetAll',
    AirTreatmentSystem_Delete = 'AirTreatmentSystemDelete',

    // ElectricalSystem
    ElectricalSystem_Create = 'ElectricalSystemCreate',
    ElectricalSystem_Update = 'ElectricalSystemUpdate',
    ElectricalSystem_Get = 'ElectricalSystemGet',
    ElectricalSystem_GetAll = 'ElectricalSystemGetAll',
    ElectricalSystem_Delete = 'ElectricalSystemDelete',

    // FirePreventionSystem
    FirePreventionSystem_Create = 'FirePreventionSystemCreate',
    FirePreventionSystem_Update = 'FirePreventionSystemUpdate',
    FirePreventionSystem_Get = 'FirePreventionSystemGet',
    FirePreventionSystem_GetAll = 'FirePreventionSystemGetAll',
    FirePreventionSystem_Delete = 'FirePreventionSystemDelete',

    // ElevatorSystem
    ElevatorSystem_Create = 'ElevatorSystemCreate',
    ElevatorSystem_Update = 'ElevatorSystemUpdate',
    ElevatorSystem_Get = 'ElevatorSystemGet',
    ElevatorSystem_GetAll = 'ElevatorSystemGetAll',
    ElevatorSystem_Delete = 'ElevatorSystemDelete',

    // PhotovoltaicSystem
    PhotovoltaicSystem_Create = 'PhotovoltaicSystemCreate',
    PhotovoltaicSystem_Update = 'PhotovoltaicSystemUpdate',
    PhotovoltaicSystem_Get = 'PhotovoltaicSystemGet',
    PhotovoltaicSystem_GetAll = 'PhotovoltaicSystemGetAll',
    PhotovoltaicSystem_Delete = 'PhotovoltaicSystemDelete',

    // LifelineSystem
    LifelineSystem_Update = 'LifelineSystemUpdate',
    LifelineSystem_Create = 'LifelineSystemCreate',
    LifelineSystem_Get = 'LifelineSystemGet',
    LifelineSystem_GetAll = 'LifelineSystemGetAll',
    LifelineSystem_Delete = 'LifelineSystemDelete',

    // AntiTheftSystem
    AntiTheftSystem_Update = 'AntiTheftSystemUpdate',
    AntiTheftSystem_Create = 'AntiTheftSystemCreate',
    AntiTheftSystem_Get = 'AntiTheftSystemGet',
    AntiTheftSystem_GetAll = 'AntiTheftSystemGetAll',
    AntiTheftSystem_Delete = 'AntiTheftSystemDelete',

    // VideoSurveillanceSystem
    VideoSurveillanceSystem_Update = 'VideoSurveillanceSystemUpdate',
    VideoSurveillanceSystem_Create = 'VideoSurveillanceSystemCreate',
    VideoSurveillanceSystem_Get = 'VideoSurveillanceSystemGet',
    VideoSurveillanceSystem_GetAll = 'VideoSurveillanceSystemGetAll',
    VideoSurveillanceSystem_Delete = 'VideoSurveillanceSystemDelete',

    // Patient118Record
    Patient118Record_Create = 'Patient118RecordCreate',
    Patient118Record_Update = 'Patient118RecordUpdate',
    Patient118Record_Get = 'Patient118RecordGet',
    Patient118Record_GetAll = 'Patient118RecordGetAll',
    Patient118Record_Delete = 'Patient118RecordDelete',
    Patient118Record_EditAfterConfirmed = 'Patient118RecordEditAfterConfirmed',

    // HealthCoordinatorRecord
    HealthCoordinatorRecord_Create = 'HealthCoordinatorRecordCreate',
    HealthCoordinatorRecord_Update = 'HealthCoordinatorRecordUpdate',
    HealthCoordinatorRecord_Get = 'HealthCoordinatorRecordGet',
    HealthCoordinatorRecord_GetAll = 'HealthCoordinatorRecordGetAll',
    HealthCoordinatorRecord_Delete = 'HealthCoordinatorRecordDelete',

    // SpecialistAssessmentRecord
    SpecialistAssessmentRecord_Create = 'SpecialistAssessmentRecordCreate',
    SpecialistAssessmentRecord_Update = 'SpecialistAssessmentRecordUpdate',
    SpecialistAssessmentRecord_Get = 'SpecialistAssessmentRecordGet',
    SpecialistAssessmentRecord_GetAll = 'SpecialistAssessmentRecordGetAll',
    SpecialistAssessmentRecord_Delete = 'SpecialistAssessmentRecordDelete',

    // RehabilitationRecord
    RehabilitationRecord_Create = 'RehabilitationRecordCreate',
    RehabilitationRecord_Update = 'RehabilitationRecordUpdate',
    RehabilitationRecord_Get = 'RehabilitationRecordGet',
    RehabilitationRecord_GetAll = 'RehabilitationRecordGetAll',
    RehabilitationRecord_Delete = 'RehabilitationRecordDelete',
    RehabilitationRecord_EditAfterConfirmed = 'RehabilitationRecordEditAfterConfirmed',

    // TinettiStaircaseRecords
    TinettiStaircaseRecord_Create = 'TinettiPerformanceRecordCreate',
    TinettiStaircaseRecord_Update = 'TinettiPerformanceRecordUpdate',
    TinettiStaircaseRecord_Get = 'TinettiPerformanceRecordGet',
    TinettiStaircaseRecord_GetAll = 'TinettiPerformanceRecordGetAll',
    TinettiStaircaseRecord_Delete = 'TinettiPerformanceRecordDelete',

    // ReconciliationPharmacologicalRecords
    ReconciliationPharmacologicalRecord_Create = 'ReconciliationPharmacologicalRecordCreate',
    ReconciliationPharmacologicalRecord_Update = 'ReconciliationPharmacologicalRecordUpdate',
    ReconciliationPharmacologicalRecord_Get = 'ReconciliationPharmacologicalRecordGet',
    ReconciliationPharmacologicalRecord_GetAll = 'ReconciliationPharmacologicalRecordGetAll',
    ReconciliationPharmacologicalRecord_Delete = 'ReconciliationPharmacologicalRecordDelete',
    ReconciliationPharmacologicalRecord_EditAfterConfirmed = 'ReconciliationPharmacologicalRecordEditAfterConfirmed',

    // ObjectivesRehabilitationRecord
    ObjectivesRehabilitationRecord_Create = 'ObjectivesRehabilitationRecordCreate',
    ObjectivesRehabilitationRecord_Update = 'ObjectivesRehabilitationRecordUpdate',
    ObjectivesRehabilitationRecord_Get = 'ObjectivesRehabilitationRecordGet',
    ObjectivesRehabilitationRecord_GetAll = 'ObjectivesRehabilitationRecordGetAll',
    ObjectivesRehabilitationRecord_Delete = 'ObjectivesRehabilitationRecordDelete',
    ObjectivesRehabilitationRecord_EditAfterConfirmed = 'ObjectivesRehabilitationRecordEditAfterConfirmed',

    // BarthelIndexRecord
    BarthelIndexRecord_Create = 'BarthelIndexRecordCreate',
    BarthelIndexRecord_Update = 'BarthelIndexRecordUpdate',
    BarthelIndexRecord_Get = 'BarthelIndexRecordGet',
    BarthelIndexRecord_GetAll = 'BarthelIndexRecordGetAll',
    BarthelIndexRecord_Delete = 'BarthelIndexRecordDelete',

    // MonitoringRestraintRecord
    MonitoringRestraintRecord_Create = 'MonitoringRestraintRecordCreate',
    MonitoringRestraintRecord_Update = 'MonitoringRestraintRecordUpdate',
    MonitoringRestraintRecord_Get = 'MonitoringRestraintRecordGet',
    MonitoringRestraintRecord_GetAll = 'MonitoringRestraintRecordGetAll',
    MonitoringRestraintRecord_Delete = 'MonitoringRestraintRecordDelete',
    MonitoringRestraintRecord_EditAfterConfirmed = 'MonitoringRestraintRecordEditAfterConfirmed',

    MonthlyRehabilitationProgramRecord_Create = 'MonthlyRehabilitationProgramRecordCreate',
    MonthlyRehabilitationProgramRecord_Update = 'MonthlyRehabilitationProgramRecordUpdate',
    MonthlyRehabilitationProgramRecord_Get = 'MonthlyRehabilitationProgramRecordGet',
    MonthlyRehabilitationProgramRecord_GetAll = 'MonthlyRehabilitationProgramRecordGetAll',
    MonthlyRehabilitationProgramRecord_Delete = 'MonthlyRehabilitationProgramRecordDelete',
    MonthlyRehabilitationProgramRecord_EditAfterConfirmed = 'MonthlyRehabilitationProgramRecordEditAfterConfirmed',
}

export const USER_GET_ALL_PERMISSIONS = [PermissionConsts.User_GetAllOperatorLike, PermissionConsts.User_GetAllBackOfficeLike, PermissionConsts.User_GetAllBeneficiaryLike];
